import { Record } from 'immutable';

import { State } from './types';

export const stateFactory = Record<State>({
  zipRequestId: undefined,
  isCreatingZipRequest: false,
  isFetchingZipRequest: false,
});
